import React, { useState ,useMemo} from 'react'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { Autocomplete, Button, TextField ,debounce} from '@mui/material'
import { ComponentState } from '../../common/models/component-state.model';
import { CommonUtils } from '../../common/services/common-utils';
import { UserService } from '../../users/user.service';
import { UserModel } from '../../common/models/user-account.model';
import AuthService from '../../../services/auth.service';
import { useNavigate } from 'react-router-dom';
import { BusyIndicator } from './BusyIndicator';
import { MessageAlert } from './MessageAlert';
import { string } from 'yup';
// import { BusyIndicator } from 'BusyIndicator';

const AdminPage = () => {
    const userService = UserService.Instance;
    const authService = AuthService.Instance;
    const navigate = useNavigate();
    
    const [userList,setUserList]= useState<UserModel[]>([])
    const [selectedUser,setSelectedUser]= useState('')
    const [state, setState] = React.useState<ComponentState>({ isLoading: false });
    function handleClose(){
    }
    async function handleSubmit(){
      setState({isLoading:true})
      try {
        const res = await authService.switchUser(selectedUser);
        setState({isLoading:false})
        navigate('/dashboard'); 
      } catch (error) {
        const errorMsg = CommonUtils.setErrorMessage(error);
        setState({isLoading:false,messageAlert:CommonUtils.setErrorMessage(errorMsg)})
      }
    }
    const onAutoCompleteChange = (keyword: string, minRole?: number) => {
      if (!keyword) return;
      setState({ isLoading: true });
      userService.searchUsers(keyword, minRole).then(res => {
        setUserList(res);
        setState({ isLoading: false });
      }).catch((err) => {
        setState({ isLoading: false, messageAlert: CommonUtils.setErrorMessage(err) });;
      });
    }
     const onAutoCompleteInputChange = useMemo(() => debounce((keyword: string, minRole?: number) => onAutoCompleteChange(keyword, minRole), 700), []);
  return (
  <>
    <MessageAlert message={state?.messageAlert}></MessageAlert>
    <BusyIndicator loading={state?.isLoading}></BusyIndicator>
    <Box 
      sx={{
        width: '100%',
        display: 'grid',
        gap: 9,
      }}>
      <Card
        sx={{
          padding:2,
        }}>
        <CardContent>
          <Typography >
            Switch Account
          </Typography>
          <Autocomplete 
          sx={{width:'40%',marginTop:1}}
          value={selectedUser||null}
          options={userList?.map((userObj)=>`${userObj?.emailId} - ${userObj?.firstName} ${userObj?.lastName} `)}
          onChange={()=>{
          }}
          onInputChange={(event,val)=>{
            onAutoCompleteInputChange(val)
            setSelectedUser(val.split(' - ')[0])
          }}
          renderInput={(params) => {
          return <TextField {...params} label="search user email..." sx={{
            bgcolor: 'background.paper',
            boxShadow: 1,
            borderRadius: 2
          }} />
        }}
          />
          <Box
            sx={{
              width: '40%',
              display: 'flex',
              marginTop: 2,
              justifyContent: 'flex-end', 
              alignItems: 'center',
            }}>
            <Button
              variant="outlined" 
              onClick={()=>{
                setSelectedUser('')
              }}
              sx={{
                color:"rgba(244, 108, 115, 1)", borderColor: "rgba(244, 108, 115, 1)",
              ':hover': { borderColor: "rgba(244, 108, 115, 1)", bgcolor: 'rgba(244, 108, 115, 1)', color: '#fff' }
              }}>
              Clear
            </Button>
            <Button  variant="contained" 
              sx={{marginInline: '10px'}} 
              onClick={()=>
                handleSubmit()
              }>
              Switch
            </Button>
          </Box>
        </CardContent>

      </Card>
    </Box>
  </>
  )
}

export default AdminPage